
import { defineComponent, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import CentroCustoModal from './CentroCustoModal.vue';
import ServicoCentroCusto from '@/servicos/Cadastros/PlanosContas/ServicoCentroCusto';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';

export default defineComponent({
  name: 'CentroCusto',
  components: {
    TelaPadraoCrud,
    CentroCustoModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoCentroCusto = new ServicoCentroCusto();
    const refCrud = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão do centro de custo';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Código', dataIndex: 'codigo', key: 'Codigo', identificadorConsulta: 'Codigo', position: 1, visible: false, ordering: true,
      },
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', identificadorConsulta: 'Descricao', position: 2, visible: true, ordering: true, customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Pai', dataIndex: 'pai', key: 'Pai', identificadorConsulta: 'Pai', position: 3, visible: true, ordering: true,
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'AtivoCentroCusto', position: 4, visible: true, align: 'left', customRenderRow: ECustomRenderRow.TagAtivo, width: 100,
      },
      {
        title: 'Ações', key: 'acoes', position: 5, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrud.value !== undefined) {
        await refCrud.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }

    return {
      crudBase,
      servicoCentroCusto,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
      refCrud,
    };
  },
});
